import {Action} from "@ngrx/store";
import {INotificationState} from "@ispm/dashboard/notification/store/notification.reducer";


export enum NotificationActionTypes {
  SetNotification = '[Notification] Set notification',
  ClearNotification = '[Notification] Clear notification',
}

export class SetNotification implements Action {
  readonly type = NotificationActionTypes.SetNotification;
  constructor(public payload: INotificationState) {
  }
}

export class ClearNotification implements Action {
  readonly type = NotificationActionTypes.ClearNotification;
}

export type NotificationActions = SetNotification | ClearNotification;
